!<template>
    <div class="screen display--flex capitalize"
        :class="[
                'screen display--flex capitalize',
                { 'screen__background--green': callFound },
                { 'screen__background--red': controler },
                { 'screen__background--blue': !controler }
            ]">
        <div
            ref="container"
            :class="[
                'screen__message capitalize',
                { 'screen__message--loading': settings.loading },
                { 'screen__message--error': settings.error }
            ]"
        >
            <icon-call-found
                class="screen__message--call-found position--absolute"
                :class="[
                    'screen__message--call-found',
                    { 'show': callFound }
                ]"
                v-if="callFound"
            />
            <div v-else>
                <icon-no-calls class="screen__message--no-calls position--absolute"
                    :class="[
                        'screen__message--no-calls',
                        { 'show': controler || settings.error }
                    ]"
                />
                <icon-search-call class="screen__message--searching position--absolute"
                    :class="[
                        'screen__message--searching',
                        { 'show': !controler && !settings.error }
                    ]"
                />
            </div>
            <span class="screen__message__text"> {{ message }} </span>
        </div>
    </div>
</template>

<script>
// package
import { reactive, toRefs, watch } from '@vue/composition-api';

export default {
    components: {
        IconSearchCall: () => import( /* webpackChunkName: 'IconSearchCall' */ '@/components/bundles/layout/images/icons/IconSearchCall' ),
        IconNoCalls: () => import( /* webpackChunkName: 'IconNoCalls' */ '@/components/bundles/layout/images/icons/IconNoCalls' ),
        IconCallFound: () => import( /* webpackChunkName: 'IconCallFound' */ '@/components/bundles/layout/images/icons/IconCallFound' )
    },
    props: {
        settings: Object
    },
    setup ( props ) {
        // obtenção das mensagens.
        const { messages } = props.settings;

        // vars reactivas
        const reactiveMessage = reactive({
            controler: false
        });
        const state = reactive({
            container: null,
            message: reactiveMessage.controler ? messages.noRequestCall : messages.request,
            callFound: props.settings.showError,
            crate: null
        });

        watch( () => props.settings.error,
            errorValue => {
                if ( errorValue )
                    state.message = messages.errorOnRegist;
            });

        watch( () => props.settings.showError,
            newValue => {
                state.crate = newValue;
                reactiveMessage.controler = !reactiveMessage.controler;
                state.message = reactiveMessage.controler ? messages.noRequestCall : messages.request;
            });
        watch( () => props.settings.toggles.callFound,
            newValue => {
                if ( newValue ) {
                    state.callFound = true;
                    state.message = messages.requestCall;
                    reactiveMessage.controler = null;
                }
            });

        return {
            ...toRefs( state ),
            ...toRefs( reactiveMessage )
        };
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Animations
    // =============================================================================
    @include keyframes( flow ) {
        to {
            background-position: 200% center;
        }
    }

    // =============================================================================
    // Style
    // =============================================================================
    .screen {
        @include position-grid( center, center );
        @include dimensions( 100%, 100% );
        @include typography-specs( 80px, 95px, 700 );
        &--out {
            opacity: 0;
        }
        &.screen__background {
            &--red{
                @include transition( all .2s ease-in-out );
                will-change: background;
                background: #FEF3F0
            }
            &--blue{
                @include transition( all .2s ease-in-out );
                will-change: background;
                background: #F1F6FF;
            }
            &--green{
                background: #ECF6F4;
            }
        }
        &__message {
            @include typography-specs( 22px, 29px, 700 );
            color: $color-dark;
            transition: all 0.3s ease-out;
            &--no-calls,
            &--searching,
            &--call-found {
                left: 0;
                right: 0;
                top: 0;
                margin: auto;
                opacity: 0;
                @include transition( opacity .3s ease-in-out );
                will-change: opacity;
            }
            &--no-calls.show,
            &--searching.show,
            &--call-found.show {
                opacity: 1;
            }
            &__text {
                display: flex;
                justify-content: center;
                margin-top: 300px;
            }

        }
    }
    .opacity--0{
        opacity: 0;
    }
    .circle-wave-1{
        left: 0;
    }
    .main-svg {
        position: absolute;
        transform: translateY( 39.5vh );
        left: 0;
        right: 0;
        margin: auto;
        overflow: unset;
    }
</style>